import { useState } from "react";
import { SettingsService } from "../../application/services/settingsService";

const settingsService = new SettingsService();

export const useSettings = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const changePassword = async (oldPassword, newPassword) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await settingsService.changePassword(
        oldPassword,
        newPassword,
      );
      if (result.success) {
        return { success: true, message: result.message };
      } else {
        setError(result.message);
        return {
          success: false,
          message: result.message,
        };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  return{
    changePassword,

    loading:loading,
    error,
    successMessage,
  }
};
